module.exports = __webpack_public_path__ + "img/clock-solid.198fbacc.svg";